import { Spinner } from "../../../lib/components";
import React, { useMemo, useState } from "react";

import NewsCard from "./components/NewsCard";
import moment from "moment";
import styles from "../../../assets/scss/pages/news.module.scss";
import useNews from "../../../hooks/useNews";
import FullNewsModal from "./components/FullNewsModal";

const News = () => {
  const { data, loading } = useNews();

  const [isFullImageModalOpen, setIsFullImageModalOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);

  const [originFilters, setOriginFilters] = useState(["local", "others"]);

  const handleNewsClick = (item) => {
    setItemSelected(item);
    setIsFullImageModalOpen(true);
  };

  const toggleOriginFilter = (newOrigin) => {
    if(newOrigin === "all") {
      setOriginFilters(["local", "others"]);
    } else {
      setOriginFilters([newOrigin]);
    }
  };

  const filteredData = useMemo(() => {
    if (originFilters.length === 2) return data;
    
    if(originFilters[0] === "local") return data.filter(_d => _d.type === undefined);
    if(originFilters[0] === "others") return data.filter(_d => _d.type !== undefined);

    return [];
  }, [data, originFilters]);

  if (loading) return <Spinner />;
  return (
    <>
      <div className={styles.absContainer}>
        <div className={styles.container}>
          <span className={styles.titleActus}>
            {" "}
            Retrouvez toutes les actualités de votre résidence :{" "}
          </span>
          <div className={styles.originFiltersContainer}>
            <button className={`${styles.originFilter} ${originFilters.length === 2 ? styles.selected : ""}`} onClick={() => toggleOriginFilter("all")}>Toutes</button>
            <button className={`${styles.originFilter} ${originFilters.length === 1 && originFilters[0] === "local" ? styles.selected : ""}`} onClick={() => toggleOriginFilter("local")}>Locales</button>
            <button className={`${styles.originFilter} ${originFilters.length === 1 && originFilters[0] === "others" ? styles.selected : ""}`} onClick={() => toggleOriginFilter("others")}>Nationales</button>
          </div>
          <div className={styles.body}>
            {filteredData
              .sort(
                (a, b) =>
                  moment(b.date.toDate()).format("YYYYMMDD") -
                  moment(a.date.toDate()).format("YYYYMMDD")
              )
              .map((item, indx) => (
                <div key={indx} className={styles.cardContainer}>
                  <NewsCard
                    item={item}
                    onClick={() => handleNewsClick(item)}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      <FullNewsModal
        isOpen={isFullImageModalOpen}
        toggle={() => {
          setIsFullImageModalOpen(false);

          const _currentNews = itemSelected;

          // Ne déselectionner l'actualité qu'une fois l'animation terminé (PS : la modale ne peut pas être ré-ouverte pendant ce temps)
          setTimeout(() => {
            setItemSelected((prevState) => prevState?.uid === _currentNews?.uid ? null : prevState);
          }, 300);
        }}
        item={itemSelected}
      />
    </>
  );
};

export default News;
